import { createContext } from '@lit/context';
import { getElementOffset } from '../ui/dom-helpers';
import { html, nothing, render } from 'lit';

export class ImagePreview {
  private imgPreview: HTMLDivElement = document.createElement('DIV') as HTMLDivElement;

  showImagePreview(imgSrc: string, classes?: string) {
    const panel = document.body;
    const template = () => {
      return html`
        <div class="m-3 p-3 border border-1 position-fixed image-preview-context ${classes ?? nothing}">
          <img class="" src=${imgSrc} alt="A big preview" />
        </div>
      `;
    };
    render(template(), this.imgPreview);

    if (!panel) return;
    const offset = getElementOffset(panel);
    const clientHeight = panel.clientHeight / 100;
    const clientWidth = panel.clientWidth / 100;
    const div = this.imgPreview.querySelector('div');
    if (div) {
      div.style.left = `${200}px`;
      div.style.top = `${offset.top + clientHeight * 10}px`;
      div.style.width = `${clientWidth * 100 - 240}px`;
      div.style.height = `${clientHeight * 80}px`;
    }
    if (!this.imgPreview.parentNode) {
      document.body.appendChild(this.imgPreview);
    }
    this.imgPreview.style.display = '';
  }

  hideImagePreview() {
    this.imgPreview.style.display = 'none';
  }
}

export const imagePreviewContext = createContext<ImagePreview>('imagepreview');
